import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import env from 'config/env';
import translationEN from './translationEN.json';
import translationPT from './translationPT.json';

// the translations

const resources = {
  en: {
    translation: translationEN,
  },
  pt: {
    translation: translationPT,
  },
};

i18n
  .use(initReactI18next) // pass i18n down to react-i18next
  .init({
    resources,
    lng: env.language,

    interpolation: {
      escapeValue: false, // react alredy safes from xss
    },
  });

export default i18n;